import React from "react";
import { observer } from "mobx-react";
import { ShowcaseCategoryViewStore } from "../../store";
import { ShowcaseCategoryViewForm } from "./ShowcaseCategoryViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type ShowcaseCategoryViewProps = {
  showcaseCategoryViewStore: ShowcaseCategoryViewStore;
};

export const ShowcaseCategoryView: React.FC<ShowcaseCategoryViewProps> =
  observer(({ showcaseCategoryViewStore }) => {
    return (
      <div>
        <ShowcaseCategoryViewForm
          code={showcaseCategoryViewStore.codeValue}
          name={showcaseCategoryViewStore.nameValue}
          onPrint={(handlePrint: () => void) =>
            showcaseCategoryViewStore.printShowcaseCategory(handlePrint)
          }
          onCancel={() => showcaseCategoryViewStore.cancelShowcaseCategory()}
          onEdit={
            showcaseCategoryViewStore.isEditEnabled
              ? () => showcaseCategoryViewStore.editShowcaseCategory()
              : undefined
          }
        />
        <ErrorDialog
          open={showcaseCategoryViewStore.errorDialogOpened}
          title={showcaseCategoryViewStore.errorTitle}
          description={showcaseCategoryViewStore.errorDescription}
          onClose={() => showcaseCategoryViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
